import { useApiPrivateRequest } from "@/shared/hooks/useApi";

export const useDisableMcpTool = () => {
  const {
    data: isDisabled,
    call,
    isLoading: isDisabling,
    isFailed: isDisableFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const disableMcpTool = async (toolName: string) => {
    await call(`/llm/mcpTools/${toolName}/disable`, "PUT");
  };

  return { isDisabled, disableMcpTool, isDisabling, isDisableFailed };
};
